import { render, staticRenderFns } from "./live-room.vue?vue&type=template&id=0ec0f19d&scoped=true"
import script from "./live-room.vue?vue&type=script&lang=js"
export * from "./live-room.vue?vue&type=script&lang=js"
import style0 from "./live-room.vue?vue&type=style&index=0&id=0ec0f19d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0f19d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec0f19d')) {
      api.createRecord('0ec0f19d', component.options)
    } else {
      api.reload('0ec0f19d', component.options)
    }
    module.hot.accept("./live-room.vue?vue&type=template&id=0ec0f19d&scoped=true", function () {
      api.rerender('0ec0f19d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/live-room.vue"
export default component.exports